import React, { Fragment } from 'react';
import { Col, Input, Label, Row } from 'reactstrap';

const Contacts = ({ allContacts, handleSelectContact, selectedContacts }) => {
  if (!allContacts) {
    return null;
  }

  // See if we have a match in the list
  const consignContacts = allContacts[0].contacts;
  const saleAdminContacts = allContacts[1].contacts;
  const expertContacts = allContacts[2].contacts;

  /**
   * If the user selected or previously had a contact selected - set the value,
   * otherwise default to first item
   */
  const selectedConsign = consignContacts.find(contact => contact.id === selectedContacts[1]);
  const selectedSaleAdmin = saleAdminContacts.find(contact => contact.id === selectedContacts[3]);
  const selectedExpert = expertContacts.find(contact => contact.id === selectedContacts[4]);

  return (
    <Fragment>
      <h3 className="mt-5">Contacts</h3>
      <Row>
        <Col>
          <Label for="selectConsignmentContact" className="font-weight-bold mb-0">
            Consignment Contact
          </Label>
          <Input
            type="select"
            onChange={e => handleSelectContact(e, 1)}
            name="select"
            id="selectConsignmentContact"
            value={selectedConsign ? selectedConsign.id : ''}
          >
            {consignContacts.map(contact => (
              <option key={contact.id} value={contact.id}>
                {contact.firstname} {contact.lastname}
              </option>
            ))}
          </Input>
        </Col>

        <Col>
          <Label for="selectSaleAdministratorContact" className="font-weight-bold mb-0">
            Sale Administrator Contact
          </Label>
          <Input
            type="select"
            onChange={e => handleSelectContact(e, 3)}
            name="select"
            id="selectSaleAdministratorContact"
            value={selectedSaleAdmin ? selectedSaleAdmin.id : ''}
          >
            {saleAdminContacts.map(contact => (
              <option key={contact.id} value={contact.id}>
                {contact.firstname} {contact.lastname}
              </option>
            ))}
          </Input>
        </Col>

        <Col>
          <Label for="selectExpertContact" className="font-weight-bold mb-0">
            Expert Contact
          </Label>
          <Input
            type="select"
            onChange={e => handleSelectContact(e, 4)}
            name="select"
            id="selectExpertContact"
            value={selectedExpert ? selectedExpert.id : ''}
          >
            {expertContacts.map(contact => (
              <option key={contact.id} value={contact.id}>
                {contact.firstname} {contact.lastname}
              </option>
            ))}
          </Input>
        </Col>
      </Row>
    </Fragment>
  );
};

export default Contacts;
